export default __webpack_public_path__ + "static/media/conference-education.dd75ac09.svg";